import { z } from "zod"

import { EMAIL_MAXIMUM_LENGTH } from "@/constants"

const emailSchema = z.string().email().max(EMAIL_MAXIMUM_LENGTH)

export const EMAIL_SEPARATORS = /[\s,;]+/

export function splitEmails(value: string): string[] {
	return value
		.split(EMAIL_SEPARATORS)
		.map((entry) => entry.trim())
		.filter(Boolean)
}

export function partitionEmails(entries: string[]) {
	const valid: string[] = []
	const invalid: string[] = []
	for (const entry of entries) {
		if (emailSchema.safeParse(entry).success) {
			valid.push(entry)
		} else {
			invalid.push(entry)
		}
	}
	return { valid, invalid }
}

export function mergeEmails(current: string[], incoming: string[]): string[] {
	return Array.from(new Set([...current, ...incoming]))
}

export function deriveName(email: string): string {
	return email.split("@")[0]?.replace(/[._-]+/g, " ") ?? email
}

export function invalidEmailMessage(invalid: string[]): string {
	if (invalid.length === 1) {
		return `"${invalid[0]}" isn't a valid email address.`
	}
	return `These aren't valid email addresses: ${invalid.join(", ")}.`
}
